module.exports = __webpack_public_path__ + "img/7.5285b7ef.jpg";